import { DashboardDeviceType } from '@akin-home/amplify';
import {
  DashboardTemplate,
  DashboardWidgetType,
  createTabletDashboardFromSelectedWidgets,
} from '@akin-home/dashboards';
/**
 * Gets dashboard options. For now, just fetches from local file
 */
export function getDashboardOptions(): DashboardTemplate[] {
  const device_type = DashboardDeviceType.tablet;

  return [
    {
      id: 'dashboard-template-1',
      name: 'Simple',
      device_type,
      layout: createTabletDashboardFromSelectedWidgets([
        DashboardWidgetType.CONTACTS,
        DashboardWidgetType.GOAL_CAROUSEL,
      ]),
    },
    {
      id: 'dashboard-template-2',
      name: 'Focused',
      device_type,
      layout: createTabletDashboardFromSelectedWidgets([
        DashboardWidgetType.CONTACTS,
        DashboardWidgetType.CHECKLISTS,
        DashboardWidgetType.GOAL_CAROUSEL,
      ]),
    },
    {
      id: 'dashboard-template-3',
      name: 'A bit of everything',
      device_type,
      layout: createTabletDashboardFromSelectedWidgets([
        DashboardWidgetType.CONTACTS,
        DashboardWidgetType.CHECKLISTS,
        DashboardWidgetType.GOAL_CAROUSEL,
        DashboardWidgetType.MEALS,
      ]),
    },
  ];
}
